module.exports = __webpack_public_path__ + "img/96.6cea6dde.jpg";